export default "__VITE_ASSET__wqtF2i4c__"